import {Link} from 'react-router-dom';

export default function Schedule() {

  return (
    <>
    
      <section className="breadcrumnd-banner">
        <div className="container">
          <div className="breadcrumnd-content text-center">
            <h3 className="text-uppercase fw-500 white-clr mb-xxl-6 mb-xl-5 mb-4">
              Schedule
            </h3>
            <ul className="breadcrumnd d-flex justify-content-center align-items-center gap-xxl-3 gap-2">
              <li>
                <Link to={'/'} className="text-uppercase fw-500">Home</Link>
              </li>
              <li>
                <i className="ph ph-caret-right"></i>
              </li>
              <li className="text-uppercase">
                Schedule
              </li>
            </ul>
          </div>
        </div>
      </section>

      <main className="main position-relative overflow-hidden" id="mains">

        <div className="episode-all-section overflow-hidden pt-space pb-space whitebg zindex1 position-relative">
          <div className="container">
            <div className="allepisode-tabbing-wrap">
              <div className="singletab position-relative">
                <iframe src="https://embed.ultrastream.io/us_iUVDPQSRyCLmxJknc" id="us_iUVDPQSRyCLmxJknc" width="100%"></iframe>
              </div>
            </div>
          </div>
        </div>

      </main>
    </>
  )
}
